(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('toolsMenu', {
        templateUrl: 'views/components/views/toolsMenu/toolsMenu.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', function (stateService) {
            const vm = this;
            
            vm.model = {
                name: stateService.getCurrentName()
            };
        }]
    });
})();
